import script from "./sidebarPriceRange.vue?vue&type=script&setup=true&lang=ts"
export * from "./sidebarPriceRange.vue?vue&type=script&setup=true&lang=ts"

import "./sidebarPriceRange.vue?vue&type=style&index=0&id=20bbd8b2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20bbd8b2"]])

export default __exports__